<template>
  <div class="d-flex flex-wrap justify-content-center justify-content-sm-between  align-items-center mt-25 ">
    <div class="d-flex flex-wrap flex-column flex-sm-row align-items-center order-0">
      <div>Copyright &copy; {{ new Date().getFullYear() }}</div>
      <b-link class="ml-sm-25" href="https://www.nyssma.org" target="_blank">New York State School Music Association</b-link>
    </div>
    <div class="font-small-2 text-muted order-2 order-sm-1">v260303.2</div>
    <div class="order-sm-2 order-1">NYSSMA<sup>&reg;</sup> – New York State School Music Association</div>
  </div>
</template>
<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
